<template>
  <page-option title="Tổng quan hệ thống">
     <template #title>
      <v-avatar color="#E3FCF7" size="35">
        <v-icon color="#108F6E" size>mdi-view-dashboard</v-icon>
      </v-avatar>
      <div class="pl-2 title-page">Tổng quan hệ thống</div>
    </template>
    <!-- Main -->
    <v-row class="mt-3">
      <v-col
        class="d-flex flex-column card-container"
        cols="4"
        lg="4"
        md="4"
        order-sm="1"
        sm="12"
        xl="4"
      >
        <v-card
          class="mx-auto sumaryCard"
          outlined
          hover
          tile
        >
          <v-list-item three-line>
            <v-avatar color="#F4F7FA" size="60" class="mr-3">
              <v-icon color="#616E7D" size="30">mdi-folder</v-icon>
            </v-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-count"
                v-if="!loading && data.workspace_count !== null">
                {{ data.workspace_count }}
              </v-list-item-title>
              <span v-else class="mb-1"
                ><v-progress-circular indeterminate></v-progress-circular
              ></span>
              <v-list-item-subtitle
                class="text-uppercase text-name"
              >
                {{ $t('sidebar.workspace.name') }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-btn icon>
              <v-icon size="15" class="footer-link-icon" @click="goToRoute('workspaces')">mdi-arrow-right</v-icon>
            </v-btn>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col
        class="d-flex flex-column card-container"
        cols="4"
        lg="4"
        md="4"
        order-sm="1"
        sm="12"
        xl="4"
      >
        <v-card
          class="mx-auto sumaryCard"
          outlined
          hover
          tile
        >
          <v-list-item three-line>
            <v-avatar color="#E3FCF7" size="60" class="mr-3">
              <v-icon color="#108F6E" size="30">mdi-layers</v-icon>
            </v-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-count"
                v-if="!loading && data.layer_count !== null">
                {{ data.layer_count }}
              </v-list-item-title>
              <span v-else class="mb-1"
                ><v-progress-circular indeterminate></v-progress-circular
              ></span>
              <v-list-item-subtitle
                class="text-uppercase text-name"
              >
                {{ $t('sidebar.layer.name') }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-btn icon>
              <v-icon size="15" class="footer-link-icon" @click="goToRoute('layers')">mdi-arrow-right</v-icon>
            </v-btn>
          </v-list-item>
        </v-card>

      </v-col>
      <v-col
        class="d-flex flex-column card-container"
        cols="4"
        lg="4"
        md="4"
        order-sm="1"
        sm="12"
        xl="4"
      >
        <v-card
          class="mx-auto sumaryCard"
          outlined
          hover
          tile
        >
          <v-list-item three-line>
            <v-avatar color="#FFE6DB" size="60" class="mr-3">
              <v-icon color="#F8924F" size="30">mdi-map</v-icon>
            </v-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-count"
                v-if="!loading && data.map_count !== null">
                {{ data.map_count }}
              </v-list-item-title>
              <span v-else class="mb-1"
                ><v-progress-circular indeterminate></v-progress-circular
              ></span>
              <v-list-item-subtitle
                class="text-uppercase text-name"
              >
                {{ $t('sidebar.layer-group.name') }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-btn icon>
              <v-icon size="15" class="footer-link-icon" @click="goToRoute('layer-group')">mdi-arrow-right</v-icon>
            </v-btn>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mt-3">
      <v-col
        class="d-flex flex-column card-container"
        cols="12"
        lg="12"
        md="12"
        order-sm="1"
        sm="12"
        xl="12"
      >
        <div class="dashboard-header text-h6 flex-grow-0">
          <span>Không gian làm việc mới nhất</span>
        </div>
        <div v-if="!loading && data.workspaces">
          <v-row class="mt-3" v-if="data.workspaces.length > 0">
            <v-col
              class="d-flex flex-column card-container"
              cols="3"
              lg="4"
              md="6"
              order-md="12"
              order-sm="12"
              sm="12"
              xl="3"
              v-for="workspace in data.workspaces"
              v-bind:key="workspace.id"
            >
              <v-card
                class="mx-auto sumaryCard"
                outlined
                hover
                tile
              >
                <v-list-item three-line>
                  <v-avatar color="#F4F7FA" size="60" class="mr-3">
                    <v-icon color="#616E7D" size="30">mdi-folder</v-icon>
                  </v-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="text-title">
                      {{ workspace.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
          </v-row>
          <div class="mt-5" v-else>Không có dữ liệu</div>
        </div>
        <div class="mt-5" v-else>
          <v-progress-circular indeterminate></v-progress-circular
        ></div>
      </v-col>
      <v-col
        class="d-flex flex-column card-container"
        cols="12"
        lg="12"
        md="12"
        order-md="2"
        order-sm="3"
        sm="12"
        xl="12"
      >
        <div class="dashboard-header text-h6 flex-grow-0">Lớp mới nhất </div>
        <div v-if="!loading && data.layers">
          <v-row class="mt-3" v-if="data.layers.length > 0">
            <v-col
              class="d-flex flex-column card-container"
              cols="3"
              lg="4"
              md="6"
              order-md="12"
              order-sm="12"
              sm="12"
              xl="3"
              v-for="layer in data.layers"
              v-bind:key="layer.id"
            >
              <v-card
                class="mx-auto sumaryCard"
                outlined
                hover
                tile
              >
                <v-list-item three-line>
                  <v-avatar color="#E3FCF7" size="60" class="mr-3">
                    <v-img
                      :aspect-ratio="1 / 1"
                      :width="iconSide"
                      :src="layer.image_url"
                      v-if="layer.image_url"
                      alt="Layers"
                    ></v-img>
                    <v-icon color="#108F6E" :size="30" v-else> mdi-layers</v-icon>
                  </v-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="text-title">
                      {{ layer.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle
                      class="text-name"
                    >
                    <div class="d-flex text-name">
                      <span
                        class="no-wrap name-text"
                        >{{ layer.workspace.name }}</span
                      >
                      <span class="mr-2 ml-2">|</span>
                      <span class="no-wrap hover_show_icon">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on: menu, attrs }">
                            <v-tooltip bottom>
                              <template v-slot:activator="{}">
                                <div
                                  light
                                  v-bind="attrs"
                                  v-on="{ ...menu }"
                                  x-small
                                  >
                                  {{ $t('sidebar.layer-group.name') }}
                                  <v-icon
                                    size="18"
                                    class="hover_show_icon_icon ml-n2"
                                  >
                                    mdi-menu-left</v-icon
                                  >
                                </div>
                              </template>
                              <!-- <span>Thuộc bản đồ</span> -->
                            </v-tooltip>
                          </template>
                          <v-list>
                            <v-list-item v-if="!layer.layer_groups.length > 0">
                              <v-list-item-title
                                >Không có dữ liệu</v-list-item-title
                              >
                            </v-list-item>
                            <v-list-item
                              v-else
                              v-for="(item, index) in layer.layer_groups"
                              :key="index"
                            >
                              <v-list-item-title>{{
                                item.name
                              }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </span>
                    </div>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
          </v-row>
          <div class="mt-5" v-else>Không có dữ liệu</div>
        </div>
        <div class="mt-5" v-else>
          <v-progress-circular indeterminate></v-progress-circular
        ></div>
      </v-col>
      <v-col
        class="d-flex flex-column card-container"
        cols="12"
        lg="12"
        md="12"
        order-md="2"
        order-sm="3"
        sm="12"
        xl="12"
      >
        <div class="dashboard-header text-h6 flex-grow-0"
          >Nhóm lớp bản đồ mới nhất
        </div>
        <div v-if="!loading && data.maps">
          <v-row class="mt-3" v-if="!loading && data.maps.length > 0">
            <v-col
              class="d-flex flex-column card-container"
              cols="3"
              lg="4"
              md="6"
              order-md="12"
              order-sm="12"
              sm="12"
              xl="3"
              v-for="map in data.maps"
              v-bind:key="map.id"
            >
              <!-- -->
              <v-card
                class="mx-auto sumaryCard"
                outlined
                hover
                tile
              >
                <v-list-item three-line>
                  <v-avatar color="#FFE6DB" size="60" class="mr-3">
                    <v-img
                      :aspect-ratio="1 / 1"
                      :width="iconSide"
                      :src="map.image_url"
                      v-if="map.image_url"
                    ></v-img>
                    <v-icon :size="30" color="#F8924F" v-else> mdi-map</v-icon>
                  </v-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="text-title">
                      {{ map.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle
                      class="text-name"
                    >
                      <div class="d-flex justify-content-between">
                        <div
                          class="no-wrap text-over-flow-ellipsis"
                          style="max-width: 80px"
                          >
                          {{ map.workspace.name }}</div
                        >
                        <span class="mr-2 ml-2">|</span>
                        <div
                          class="no-wrap text-over-flow-ellipsis hover_show_icon"
                        >
                          <v-menu>
                            <template v-slot:activator="{ on: menu, attrs }">
                              <v-tooltip bottom>
                                <template v-slot:activator="{}">
                                  <div
                                    light
                                    v-bind="attrs"
                                    v-on="{ ...menu }"
                                    x-small
                                    >
                                    {{ $t('sidebar.layer.name') }}
                                    <v-icon
                                      size="18"
                                      class="hover_show_icon_icon ml-n1"
                                    >
                                      mdi-menu-left</v-icon
                                    >
                                  </div>
                                </template>
                              </v-tooltip>
                            </template>
                            <v-list>
                              <v-list-item v-if="!map.layers.length > 0">
                                <v-list-item-title
                                  >Không có dữ liệu</v-list-item-title
                                >
                              </v-list-item>
                              <v-list-item
                                v-else
                                v-for="(item, index) in map.layers"
                                :key="index"
                              >
                                <v-list-item-title>{{
                                  item.name
                                }}</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </div>
                      </div>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
          </v-row>
          <div class="mt-5" v-else>Không có dữ liệu</div>
        </div>
        <div class="mt-5" v-else>
          <v-progress-circular indeterminate></v-progress-circular
        ></div>
      </v-col>
    </v-row>
  </page-option>
</template>
<script>
import { API_OVERVIEW } from '@api'
import { ConfirmBuilder } from '@utils'
import { mapGetters } from 'vuex'
import { EDIT_TYPE } from '@constant'
export default {
  mixins: [],
  components: {},
  props: {},
  data: (vm) => ({
    default_params: {
      workspace_id: vm.id,
    },
    data: {},
    loading: false,
    iconSide: 70,
  }),
  watch: {},
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
  },
  created() {},
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      this.data = await API_OVERVIEW.getSummaryData()
      this.data = this.data.data
      this.loading = false
    },
    goToRoute(routeName) {
      this.$router.push({ name: routeName })
    },
  },
}
</script>
<style scope>
.no-wrap {
  white-space: nowrap;
}
.text-over-flow-ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
}
.hover-transform-up:hover {
  /* transition: 200ms; */
  transform: translateY(-2px);
}
.hover-underline:hover {
  text-decoration: underline;
  cursor: pointer;
}
.name-text {
  /* color: #004f3f; */
}
.hover_show_icon_icon {
  opacity: 0;
  margin-top: -1px;
}
.hover_show_icon:hover .hover_show_icon_icon {
  transform: rotate(-90deg);
  opacity: 1;
}
.footer-link {
  background-color: rgb(239, 239, 239);
}
.footer-link:hover {
  background-color: rgb(219, 219, 219);
}
.sumaryCard{
  width: 100%;
  height: 86px;
  left: 0px;
  top: 0px;

  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  box-sizing: border-box;
  border-radius: 8px;
}
.sumaryCardIcon{
background: #F4F7FA;

}
.sumaryCard:hover .sumaryCardIcon {
  transform: scale(1.1);
  transition: 200ms;
}
.footer-link-icon {
  /* margin-top: -1px; */
}
.text-count{
  width: 22px;
  height: 42px;
  left: 90px;

  font-style: normal;
  font-weight: 500;
  font-size: 32px;
  line-height: 20px;

  letter-spacing: 0.25px;

  color: #001E2B;
}
.text-name{
  width: 140px;
  height: 20px;
  left: 93px;

  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  /* identical to box height, or 167% */

  letter-spacing: 0.25px;

  color: #001E2B;
}
.text-title{
  width: 50px;
  height: 30px;
  left: 90px;

  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  /* or 111% */

  letter-spacing: 0.25px;

  color: #001E2B
}
</style>
